import React from 'react';
import './Class.css';
import class12 from '../../Images/Class-12.png';
import {Helmet} from "react-helmet";
const Class12 = () => (
  <div className="explore-container">
    <Helmet>
                <meta charSet="utf-8" />
                <title>Final Orbit - Otter Tutor</title>
                <link rel="canonical" href="http://ottertutors.com" />
            </Helmet>
    {/* Back Button */}
    <button className="back-button" onClick={() => window.history.back()}>
      ← Back
    </button>
    {/* Lakshya Card (Right Side, Above Header) */}
    <div className="lakshya-card">
      <img
        src={class12} 
        loading="lazy"
        alt="Lakshya NEET 3.0"
        className="lakshya-image"
      />
      <div className="course-details">
  <p className="pricing">💳 Monthly Fees: ₹ 1599/-</p>
  <p className="pricing">💼 Fees Billed Till Exams: ₹ 7999/-</p>
  <a href="https://rzp.io/rzp/finalorbit" target="_blank" rel="noopener noreferrer">
    <button className="buy-button">Buy Now</button>
  </a>
</div>

    </div>

    {/* Lakshya Header (Full Width) */}
    <div className="lakshya-header">
      <div className="lakshya-header-content">
        <h2 className="lakshya-title">Final <span className='highlight'>Orbit</span>(Class-<span className='highlight'>12</span>)</h2>
        
      </div>
    </div>

    {/* Batch Details Section */}
    <div className="batch-details">
      <h3>Description</h3>
      <ul>
  <li><strong>1️⃣Focused Learning with Small Batches</strong>  
    <ul>
      <li>🌱 Only 10 students per batch for personalized attention, helping you excel in every subject.</li>
    </ul>
  </li>
  <li><strong>2️⃣Subjects to Master in Class 12</strong>  
    <ul>
      🧮 Mathematics
      🔬 Physics
      ⚗️ Chemistry
      🧬 Biology
    </ul>
  </li>
  <li><strong>3️⃣Daily Class Schedule</strong>  
    <ul>
      <li>🕒 Two interactive 1-hour sessions per day to make learning enjoyable and effective!</li>
    </ul>
  </li>
  <li><strong>4️⃣24/7 Doubt-Solving Support</strong>  
    <ul>
      <li>🩵 Round-the-clock support—you can always reach out with your doubts, anytime!</li>
    </ul>
  </li>
  <li><strong>5️⃣Live & Engaging Classes</strong>  
    <ul>
      <li>👩‍🏫 Live interactive sessions with experienced tutors, making complex concepts simple and fun.</li>
    </ul>
  </li>
  <li><strong>6️⃣Learning Through Experiments</strong>  
    <ul>
      <li>🔬 Conduct hands-on experiments to visualize and understand scientific theories better.</li>
    </ul>
  </li>
  <li><strong>7️⃣Topic-Wise Practice Sheets</strong>  
    <ul>
      <li>📝 Practice sheets designed for every topic to help you master each subject and perform well in exams.</li>
    </ul>
  </li>
  <li><strong>8️⃣Weekly Tests & Quizzes</strong>  
    <ul>
      <li>🎯 Regular tests and live quizzes to track your progress and keep you on your toes!</li>
    </ul>
  </li>
  <li><strong>9️⃣1-on-1 Doubt Solving</strong>  
    <ul>
      <li>💬 Get personalized attention with one-on-one doubt solving whenever you need it!</li>
    </ul>
  </li>
  <li><strong>🔟Real-Life Applications</strong>  
    <ul>
      <li>🌍 Learn how science, mathematics, and other concepts are applied in real-world scenarios.</li>
    </ul>
  </li>
  <li><strong>1️⃣1️⃣Free Coding Classes</strong>  
    <ul>
      <li>💻 FREE Coding Course to build valuable tech skills and future-proof your career.</li>
    </ul>
  </li>
  <li><strong>1️⃣2️⃣Expert Guidance</strong>  
    <ul>
      <li>👨‍🏫 Learn from expert tutors who are passionate about helping you achieve academic excellence.</li>
    </ul>
  </li>
  <li><strong>1️⃣3️⃣For Any Queries</strong>  
    <ul>
      <li>📬 Reach us at <a href="mailto:support@ottertutors.com">support@ottertutors.com</a> for any assistance!</li>
    </ul>
  </li>
  <li><strong>🌟 What Makes Us Different?</strong>  
    <ul>
      <li>✨ Expert tutors who are dedicated to your success.</li>
      <li>🌍 Real-world connections to make every lesson meaningful.</li>
    </ul>
  </li>
  <br/>
  <li><strong>🚀 Join <span className='highlight1'>"Final Orbit"</span> Accelerate your academic journey to new heights with expert tutors, personalized learning, and continuous support!</strong>  
    
  </li>
</ul>

    </div>

     {/* FAQ Section */}
     <div className="faq-section">
      <h2>FAQs</h2>
      <p style={{ textAlign: 'center' }}>
  Here are some of the frequently asked questions:
</p>
      <div className="faq-grid">
        <div className="faq-item">
        🎯
          <div>
            <h3>Who Should Join "Final Orbit"?</h3>
            <p>
            🎓 Ideal for Class 12 students who are aiming for top scores in their board exams (CBSE Pattern)
            </p>
          </div>
        </div>
        <div className="faq-item">
        🎯
          <div>
            <h3>Where Will the Classes Be Held?
            </h3>
            <p>💻 Classes will be conducted on Zoom, and links will be shared via our WhatsApp groups for easy access.
            </p>
          </div>
        </div>
        <div className="faq-item">
        🎯
          <div>
            <h3>How Can I Get Help If I Have Doubts?</h3>
            <p> 💬 24/7 doubt-solving support to help you out with any question you may have, any time of the day!
            </p>
          </div>
        </div>
        <div className="faq-item">
        🎯
          <div>
            <h3>What If I Miss a Class?</h3>
            <p>
            📼 Don't worry! All classes are recorded and available for you to catch up at any time.
            </p>
          </div>
        </div>
        <div className="faq-item">
        🎯
          <div>
            <h3>Are Tests and Quizzes Mandatory?</h3>
            <p>
            ✅ Yes! Weekly tests and live quizzes are essential to track your progress and keep you focused.
            </p>
          </div>
        </div>
        <div className="faq-item">
        🎯
          <div>
            <h3>Can I get a refund after batch purchase?</h3>
            <p>
            💡 Refunds are not available after batch purchase due to our investment in providing the best learning experience. Please make a well-thought-out decision before purchasing.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default Class12;
